import { Input as InputA, InputProps } from 'antd';
import React, { FC } from 'react';

export const Input: FC<InputProps> = (props) => <InputA {...props} />;
